/**
 * Created by Alejandro Heredia <alejandro.heredia@softgames.de> on 2019-09-05.
 * Copyright © Softgames 2019 - present
 */

const GEO_API_URL = 'https://get.geojs.io/v1/ip/country.json';
const GEO_KEY_MAP = {ip: 'ip', country: 'country'};
const GEO_RETRIEVE_METHOD = 'GET';
const GEO_TIMEOUT = 10000;

const GEO_CONFIG = {
  apiURL: GEO_API_URL,
  keyMap: GEO_KEY_MAP,
  method: GEO_RETRIEVE_METHOD,
  timeout: GEO_TIMEOUT,
};

/**
 * Created by Alejandro Heredia <alejandro.heredia@softgames.de> on 2019-09-05.
 * Copyright © Softgames 2019 - present
 */

/**
 * GeoResult
 * Standard class prototype for providing a consistent object result
 */
class GeoResult {
  constructor(props) {
    Object.keys(props).forEach(key => {
      if (props[key]) {
        this[key] = props[key];
      }
    });
  }
}

/**
 * Created by Alejandro Heredia <alejandro.heredia@softgames.de> on 2019-09-05.
 * Copyright © Softgames 2019 - present
 */

/**
 * Utility method for mapping the service response object to a standard GeoResult one
 * @param {object} result | The response object from the service
 * @param {object} keyMap | The object that maps the response values to the standard GeoResult object
 * @returns {GeoResult}
 */
const mapResult = (result, keyMap) => {
  const obj = {};
  Object.keys(keyMap).forEach(key => {
    if (keyMap[key] && result[keyMap[key]]) {
      obj[key] = result[keyMap[key]];
    }
  });
  return new GeoResult(obj);
};

/**
 * Created by Alejandro Heredia <alejandro.heredia@softgames.de> on 2019-09-05.
 * Copyright © Softgames 2019 - present
 */

/**
 * Valid Response
 * Utility method for validating data response object
 * @param {any} data
 * @returns {boolean}
 */
const validResponse = data => data && typeof data === 'object' && Object.keys(data).length > 0;

/**
 * Created by Alejandro Heredia <alejandro.heredia@softgames.de> on 2019-09-05.
 * Copyright © Softgames 2019 - present
 */

/**
 * Get Country
 * Retrieving geo localization country and ip information from a service
 *
 * import { getCountry } from '@sgorg/geo-client';
 const { ip, country } = await getCountry({apiURL: 'https://get.geojs.io/v1/ip/country.json', keyMap: {ip: 'ip', country: 'country', method: 'GET', responseType: 'json'}});
 console.log(`IP: ${ip}, Country: ${country}`);
 * @param {IConfig} config
 * @returns {Promise<GeoResult>}
 */


/**
 * @async
 * @function
 * @description
 * Retrieving geo localization country and ip information from a third-party service
 *
 * @example
 * import { getCountry } from '@sgorg/geo-client';
 * async function getCurrentCountry() {
 *   const { ip, country } = await getCountry();
 *   console.log(`IP: ${ip}, Country: ${country}`);
 *   return country;
 * }
 *
 * @param {IConfig} config
 * @returns {Promise<IGeoResult>}
 */
function getCountry(config = {}) {
  const {apiURL, keyMap, method, timeout} = {
    ...GEO_CONFIG,
    ...config,
  };
  return new Promise((resolve, reject) => {
    let timeoutId = null;
    const callback = (error, result) => {
      if (timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
      if (error) {
        reject(error);
      } else {
        resolve(result);
      }
    };
    try {
      const xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function() {
        try {
          if (this.readyState === 4) {
            if (this.status !== 200) {
              throw new Error(`Invalid response status "${this.status}"`);
            }
            const data = JSON.parse(this.responseText);
            if (!validResponse(data)) {
              throw new Error(`Invalid response from API`);
            }
            const result = mapResult(data, keyMap);
            callback(null, result);
          }
        } catch (error) {
          callback(error);
        }
      };
      timeoutId = setTimeout(() => {
        callback(new Error(`Request timed out after ${timeout}ms`));
      }, timeout);
      xhr.open(method, apiURL);
      xhr.send();
    } catch (e) {
      callback(e);
    }
  });
}



var country = /*#__PURE__*/Object.freeze({
  getCountry: getCountry
});

/**
 * Created by Alejandro Heredia <alejandro.heredia@softgames.de> on 2019-09-05.
 * Copyright © Softgames 2019 - present
 */

var index = {
  ...country,
};

export default index;
export { getCountry };
